import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CreateOrUpdateProductRequest, ProductResponse } from "./productsApi";
import { createProduct } from "./productsApi";

export const useCreateProduct = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createProductMutation = useMutation<ProductResponse, unknown, CreateOrUpdateProductRequest>({
    mutationFn: (v) => createProduct(v),
    onSuccess: (data) => {
      enqueueSnackbar(`Produkt ${data.name} został utworzony`, { variant: "success" });
      queryClient.setQueryData(["products", data.id], data);
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się stworzyć produktu. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return { createProduct: (request: CreateOrUpdateProductRequest) => createProductMutation.mutateAsync(request) };
};
